import PropTypes from 'prop-types';
import { Chip, IconButton, TableCell, TableRow } from '@mui/material';
import Iconify from '../../../components/iconify';
import { paths } from '../../../routes/paths';
import { useRouter } from '../../../routes/hooks';

const STATUS_OPTIONS = {
  draft: { label: 'Draft', color: 'default' },
  approved: { label: 'Approved', color: 'success' },
  under_review: { label: 'Review Needed', color: 'default' },
  rejected: { label: 'Rejected', color: 'error' },

};


export default function TelePackageTableRow({ row }) {
  const { _id,user_name, telecare_package_id, status,package_name } = row;
  const router = useRouter();
  const handleEdit = () => {
    router.push(paths.doctor_dashboard.edit_responses.replace(':userResponseId', _id));
  };
  return (
    <TableRow hover>
      <TableCell>{user_name}</TableCell>

      <TableCell>{package_name}</TableCell>

      <TableCell>
        <Chip
          label={STATUS_OPTIONS[status]?.label}
          color={STATUS_OPTIONS[status]?.color}
        />
      </TableCell>

      <TableCell>
        <IconButton size="small" onClick={handleEdit}>
          <Iconify icon="tabler:edit" width={24} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

TelePackageTableRow.propTypes = {
  row: PropTypes.shape({
    user_name: PropTypes.string.isRequired,
    package_name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['draft', 'under_review', 'approved','rejected']).isRequired,
  }).isRequired,
};
